import { RateItem } from '../models/rate.types';

export interface ShippingContextFields {
  country?: string;
  zone?: string;
  courier?: string;
  service?: string;
}

export function extractShippingContext(item: RateItem): ShippingContextFields {
  return {
    country: item.country_name || item.country?.name || undefined,
    zone: item.courier_zone_name || item.courier_zone?.name || undefined,
    courier: item.courier_name || item.courier?.name || undefined,
    service: item.courier_service_name || item.courier_service?.name || undefined,
  };
}

export function hasShippingContext(fields: ShippingContextFields): boolean {
  return Boolean(fields.country || fields.zone || fields.courier || fields.service);
}

export interface ShippingContextRow {
  key: keyof ShippingContextFields;
  label: string;
  value: string;
}

export function getOrderedShippingContextRows(
  fields: ShippingContextFields,
  labels: {
    country: string;
    zone: string;
    courier: string;
    service: string;
  },
): ShippingContextRow[] {
  const entries: ShippingContextRow[] = [
    { key: 'country', label: labels.country, value: fields.country ?? '' },
    { key: 'zone', label: labels.zone, value: fields.zone ?? '' },
    { key: 'courier', label: labels.courier, value: fields.courier ?? '' },
    { key: 'service', label: labels.service, value: fields.service ?? '' },
  ];

  return entries.filter((entry) => entry.value.trim().length > 0);
}

export function formatShippingContextSummary(fields: ShippingContextFields): string {
  return [fields.country, fields.zone, fields.courier, fields.service].filter(Boolean).join(' · ');
}
